export default __webpack_public_path__ + "static/media/missing_floor_plan_he.d51fb88d.svg";